export const formattingDurationResult = (duration: plugin.Duration) => {
  const years = duration.get("years");
  const months = duration.get("months");
  const days = duration.get("days");
  const hours = duration.get("hours");
  const minutes = duration.get("minutes");

  let result = "";

  if (years) {
    result += `${years}y `;
  }

  if (months) {
    result += `${months}m `;
  }

  if (days) {
    result += `${days}d `;
  }

  if (hours) {
    result += `${hours}h `;
  }

  if (minutes) {
    result += `${minutes}min `;
  }

  return result;
};
